exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media only screen and (device-aspect-ratio: 40 / 71) {\n  .AwairLogo__AwairLogo__1Z7RE {\n    position: absolute;\n    margin-top: 4px;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n        -ms-transform: translateX(-50%);\n            transform: translateX(-50%); } }\n", ""]);

// exports
exports.locals = {
	"AwairLogo": "AwairLogo__AwairLogo__1Z7RE"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/circleci/project/src/styles"]}!./src/app/intro/components/Logo/AwairLogo.scss
// module id = 671
// module chunks = 0